<script>
    export let productName = 'more';
    export let productRegionalName = '';
    export let productImage = '';
    export let productImageCaption = '';
    export let productOfferedPrice = '';
    export let productRetailPrice = '';

    let borderRadius ='1rem';
</script>

<style>
    .product-card{
        position: relative;
        display: inline-block;
        width: 100%;
        border-radius: var(--border-radius) var(--border-radius) 1.4rem 1.4rem;
        color: #333333;
        box-sizing: border-box;
        text-decoration: none;
        overflow-x: hidden;
        box-shadow: 0px 0px 5px 0px rgba(221,221,221,1);
    }

    a.product-card:active{
        background-color: #FFFF00;
    }

    .product-card__image-box{
        width: 100%;
        height: 10.7rem;
        border-bottom: 1px solid #F3F3F3;
        text-align: center;
    }

    .product-card__image{
        width: 10.7rem;
        height: 10.7rem;
        object-fit: cover;
        object-position: center;
        background-color: #999999;
        border-radius: var(--border-radius) var(--border-radius) 0  0 ;
        box-sizing: border-box;
    }

    .product-card__description{
        margin: 0.5rem;
        font-size: 0.9rem;
    }

    .product-card__name{
        padding-bottom: 0.2rem;
        font-weight: 600;
    }

    .product-card__unit-price{
        padding: 0.5rem 0 0.5rem 0;
    }

    .product-card__offered-price{
        margin-left: 0.5rem;
        font-size: 1.1rem;
        /* font-weight: 500; */
        vertical-align: middle;
    }

    .product-card__retail-price{
        font-weight: 300;
        text-decoration: line-through;
        color: #999999;
        text-decoration-color: #999999;
        vertical-align: middle;
    }
    .cta{
        padding: 0.5rem 0;
    }
    

</style>

<a href='#product-page' class='product-card' style='--border-radius: {borderRadius}'>
    <div class='product-card__image-box'>
        <img class='product-card__image' src={productImage} alt={productImageCaption}>
    </div>
    <div class='product-card__description'>
        <div class='product-card__name'>{productName}</div>
        <div class='product-card__regional-name'>{productRegionalName}</div>
        <div class='product-card__unit-price'>
            <span class='product-card__retail-price'>₹{productRetailPrice}</span>
            <span class='product-card__offered-price'>₹{productOfferedPrice}</span>
        </div>
        <!-- <button class='button sec-button'>View</button> -->
        <button class='button cta'>ADD</button>
    </div>
</a>
